import { render, staticRenderFns } from "./EditBatchUploadDy.vue?vue&type=template&id=2a388456&scoped=true&"
import script from "./EditBatchUploadDy.vue?vue&type=script&lang=js&"
export * from "./EditBatchUploadDy.vue?vue&type=script&lang=js&"
import style0 from "./EditBatchUploadDy.vue?vue&type=style&index=0&id=2a388456&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a388456",
  null
  
)

export default component.exports